module.exports = __webpack_public_path__ + "media/images/covid/menu/transport-c15cd6e5d731ed69e8a0aa36d38a6776.png";